import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App.tsx";
import "./index.css";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// Local design preview: render the app without Clerk (production keys refuse to
// run on localhost). Enabled with VITE_PREVIEW=1; off for every normal build.
const PREVIEW = import.meta.env.VITE_PREVIEW === "1";

if (!PREVIEW && !PUBLISHABLE_KEY) {
  throw new Error(
    "Missing VITE_CLERK_PUBLISHABLE_KEY. Set it in .env.local (dev) or as a build-time var (deploy).",
  );
}

// Clerk widgets tuned to the monochrome editorial palette: graphite on white,
// sharp corners, Inter for UI text. Orange is reserved for accents, so the
// primary action stays graphite.
const clerkAppearance = {
  variables: {
    colorBackground: "#ffffff",
    colorPrimary: "#202020",
    colorText: "#202020",
    colorTextSecondary: "#4d4d4d",
    colorInputBackground: "#ffffff",
    colorInputText: "#202020",
    colorNeutral: "#202020",
    borderRadius: "0px",
    fontFamily: '"Inter", ui-sans-serif, system-ui, sans-serif',
  },
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {PREVIEW ? (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    ) : (
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        appearance={clerkAppearance}
        afterSignOutUrl="/"
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ClerkProvider>
    )}
  </StrictMode>,
);
